<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'

@Component({})
export default class Alert extends Vue {
  /**
   * Wraps a Boostrap Alert and adds icon.
   */
}
</script>

<template>
  <div class="animated fadeInDown">
    <b-alert v-bind="$attrs" show dismissible fade>
      <div class="row align-items-center">
        <div class="col-auto pr-1">
          <img v-if="$attrs.variant == 'success'" src="@/assets/icons/checkmark-ribbon.svg" height="25" />
          <img v-else-if="$attrs.variant == 'warning'" src="@/assets/icons/exclamation.svg" height="25" />
          <img v-else-if="$attrs.variant == 'danger'" src="@/assets/icons/exclamation.svg" height="25" />
        </div>
        <div class="col">
          <slot />
        </div>
      </div>
    </b-alert>
  </div>
</template>
